<template>
  <div
      :style="backgroundStyle"
      :class="{ darkClass: darkMode, 'extra-large-clock': isExtraLargeTime }"
      class="topDiv"
      lazy="loading"
      @click="onLog(false, $event)"
      @touchstart="longPressStart(false, $event)"
      @touchend="longPressEnd"
  >
    <!-- 顶部 20%：设置按钮 -->
    <div class="setting-row">
      <van-button
          class="setting"
          type="default"
          @click.stop="user"
          @touchend.stop
          style="border-radius: 0.5em"
      >
        <van-icon name="setting-o" class="btn-icon" style="color: #3b82c4" />
      </van-button>
    </div>

    <!-- 中部 30%：日期 + 时间 -->
    <div
      ref="timeRow"
      class="date-time-row"
      :class="timeShowFontSizeClass"
      v-show="timeShowFlg"
    >
      <div
        v-if="isExtraLargeTime"
        ref="extraClock"
        class="extra-clock-content"
        :style="{ transform: 'translateX(-50%) scale(' + extraTimeScale + ')' }"
      >
        <div class="date">
          <p>{{ yearStr }}</p>
          <p>{{ weekdayStr }}</p>
        </div>
        <div class="time">{{ timeStr }}</div>
      </div>
      <template v-else>
        <div class="date">
          <p style="margin-right: 0.5rem">{{ yearStr }}</p>
          <p style="margin-left: 0.5rem">{{ weekdayStr }}</p>
        </div>
        <div ref="timeWrap" class="time-wrap">
          <div
            ref="timeText"
            class="time"
            :style="{ transform: 'scale(' + timeScale + ')' }"
          >
            <span ref="timeTextInner">{{ timeStr }}</span>
          </div>
        </div>
      </template>
    </div>

    <!-- 底部 50%：拨打 & 录音 -->
    <div
        class="action-row"
        :class="{ 'has-record': recordButtonShow, 'no-record': !recordButtonShow }"
    >
      <!-- 拨打按钮 -->
      <div
          class="to-call"
          v-if="showCallIcon"
          @click.stop="onLog(true, $event)"
          @touchstart.stop="longPressStart(true, $event)"
          @touchend="longPressEnd"
      >
        <van-icon name="phone" class="phone_icon" />
      </div>
      <!-- 录音按钮 -->
      <div
          class="record-btn"
          v-if="recordButtonShow"
          @click.stop="showAudioRecordPopUp"
      >
        <div class="record-button-container">
          <img
              :src="require('@/assets/img/recordaudio/record_on.svg')"
              alt="録音"
              class="record-icon"
          />
          <div class="record-hint">
              クリックすると、録音を開始
          </div>
        </div>
      </div>
    </div>

    <!-- 录音弹窗 -->
    <van-popup v-model:show="recordPopUpShow" round position="center">
      <div class="memo-popup" @click.stop>
        <div class="memo-title">病棟号を入力してください</div>
        <van-field
            v-model="recordAudio.memo"
            type="text"
            placeholder="病棟号を入力してください"
            class="memo-input"
        />
        <div class="memo-hint">
          ※30分以上経過すると、録音は自動的に終了します
        </div>
        <div class="memo-buttons">
          <van-button type="default" @click.stop="recordPopUpShow = false">
            キャンセル
          </van-button>
          <van-button type="primary" @click.stop="toggleAudioRecording">
            OK
          </van-button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { RefreshUserInfo } from "@/services/login";
import { getWaitBackgroundList } from "@/services/waitBackground";
import { BASE_URL } from "@/services/api";
import { upsertClickLog } from "@/services";
import moment from "moment";

export default {
  emits: ["callTeam", "monitor"],
  data() {
    return {
      yearStr: "",
      weekdayStr: "",
      timeStr: "",
      timeOutEvent: null,
      imageUrl: "",
      imageList: [],
      imageUrls: [],
      imageIndex: 0,
      imageInterval: null,
      preloadedImages: [],
      myTimeDisplay: null,
      isIos: true,
      darkMode: false,
      timeShowFlg: false,
      darkModeType: "auto",
      showCallIcon: true,
      recordPopUpShow: false,
      recordButtonShow: false,
      timeShowFontSize: 2,
      recordAudio: {
        memo: "",
      },
      db: null,
      cachedBgNames: [],
      timeScale: 1,
      extraTimeScale: 1,
      clockViewportHeight: window.innerHeight,
    };
  },
  created() {
    this.iosOrAndroid();
  },
  mounted() {
    const dm = localStorage.getItem("darkModeType");
    if (dm) this.darkModeType = dm;
    const sci = localStorage.getItem("showCallIcon");
    if (sci) this.showCallIcon = JSON.parse(sci);

    this.initImgList();
    if (this.myTimeDisplay) clearInterval(this.myTimeDisplay);
    this.getNowTime();
    this.myTimeDisplay = setInterval(() => this.getNowTime(), 1000);
    this.checkShow();
    window.addEventListener("resize", this.adjustTimeScale);
    if (typeof ResizeObserver !== "undefined") {
      this.clockResizeObserver = new ResizeObserver(() => {
        if (this.isExtraLargeTime) this.adjustTimeScale();
      });
      this.clockResizeObserver.observe(this.$refs.timeRow);
    }
    this.$emit("changeRecordAudioStatus", false);
  },
  beforeUnmount() {
    if (this.myTimeDisplay) clearInterval(this.myTimeDisplay);
    if (this.imageInterval) clearInterval(this.imageInterval);
    window.removeEventListener("resize", this.adjustTimeScale);
    this.clockResizeObserver?.disconnect();
    this.$emit("changeRecordAudioStatus", false);
  },
  methods: {
    showAudioRecordPopUp() {
      this.recordAudio.memo = "";
      this.recordPopUpShow = true;
    },
    async toggleAudioRecording() {
      this.recordPopUpShow = false;
      this.$router.push({
        path: "/patientrecord",
        query: {
          startRecord: true,
          memo: this.recordAudio.memo,
        },
      });
    },
    longPressStart(isIcon, e) {
      if (this.timeOutEvent) clearTimeout(this.timeOutEvent);
      this.timeOutEvent = setTimeout(() => this.onLog(isIcon, e), 1000);
    },
    longPressEnd() {
      if (this.timeOutEvent) clearTimeout(this.timeOutEvent);
    },
    async onLog(isIcon, e) {
      try {
        const user = JSON.parse(
            localStorage.getItem(process.env.VUE_APP_USER_KEY)
        );
        if (user?.is_full_screen_call !== "1" && !isIcon) return;
        if (isIcon) e.stopPropagation();
        let device_id = "";
        if (window.device?.uuid) device_id = JSON.stringify(device);
        await upsertClickLog({
          device_id,
          click_time: moment().format("YYYY-MM-DD HH:mm:ss"),
          click_position: JSON.stringify([e.clientX, e.clientY]),
        });
        this.toCall();
      } catch (error) {
        console.error(error);
      }
    },
    async checkShow() {
      const ret = await RefreshUserInfo();
      const u = ret.data.data.user;
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(u));
      this.timeShowFlg = u.time_show_flg === "1";
      this.timeShowFontSize = Number(u.time_show_font_size) || 2;
      this.recordButtonShow = u.auth_list.includes("audio_record");
      this.getNowTime();
      this.adjustTimeScale();
    },
    async initImgList() {
      const ret = await getWaitBackgroundList();
      if (ret.data.code >= 0 && ret.data.data) {
        const names = ret.data.data;
        // 读出 IndexedDB 中已有的名字
        this.cachedBgNames = await this.loadCachedNames();
        // 删除已不在 names 里的旧缓存
        for (const oldName of this.cachedBgNames) {
          if (!names.includes(oldName)) {
            await this.deleteImageFromCache(oldName);
          }
        }
        // 每个名字：若缓存中已存在则直接用，否则下载并存入缓存
        this.imageUrls = await Promise.all(names.map(async n => {
          const urlPath = `${BASE_URL}/getBackGroundImage/${n}`;
          const blob = await this.getImageFromCache(n);
          if (blob) {
            return URL.createObjectURL(blob);
          } else {
            // 请求图片并存储
            const resp = await fetch(urlPath);
            const b = await resp.blob();
            await this.saveImageToCache(n, b);
            return URL.createObjectURL(b);
          }
        }));
        // 初始化轮播
        this.imageIndex = 0;
        this.imageUrl = this.imageUrls[0] || '';
        if (this.imageInterval) clearInterval(this.imageInterval);
        this.imageInterval = setInterval(this.setBackgroundImg, 5000);
      }
    },
    setBackgroundImg() {
      if (!this.imageUrls.length) return;
      this.imageIndex =
          (this.imageIndex + 1) % this.imageUrls.length;
      this.imageUrl = this.imageUrls[this.imageIndex];
    },
    getNowTime() {
      const local = new Date();
      const jp = new Date(
          local.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" })
      );
      const days = [
        "日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"
      ];
      const year = this.isExtraLargeTime
          ? `${jp.getFullYear()}年`
          : `${jp.getFullYear()}/${this.addZero(jp.getMonth()+1)}/${this.addZero(jp.getDate())}`;
      const weekday = this.isExtraLargeTime
          ? `${jp.getMonth()+1}月${jp.getDate()}日(${days[jp.getDay()][0]})`
          : days[jp.getDay()];
      const hoursMinutes = `${this.addZero(jp.getHours())}:${this.addZero(jp.getMinutes())}`;
      const time = this.isExtraLargeTime
          ? hoursMinutes
          : `${hoursMinutes}:${this.addZero(jp.getSeconds())}`;
      const displayChanged = this.yearStr !== year || this.weekdayStr !== weekday || this.timeStr !== time;
      this.yearStr = year;
      this.weekdayStr = weekday;
      this.timeStr = time;
      const h = jp.getHours();
      if (this.darkModeType === "on") this.darkMode = true;
      else if (this.darkModeType === "off") this.darkMode = false;
      else this.darkMode = h >= 20 || h < 6;
      if (displayChanged) this.adjustTimeScale();
    },
    adjustTimeScale() {
      if (this.isExtraLargeTime) this.clockViewportHeight = window.innerHeight;
      this.$nextTick(() => {
        if (this.isExtraLargeTime) {
          const row = this.$refs.timeRow;
          const content = this.$refs.extraClock;
          if (!row || !content || !content.offsetWidth || !content.offsetHeight) return;
          // 按剩余空间放大或缩小，使用原始尺寸避免连续计算产生缩放偏差。
          this.extraTimeScale = Math.min(
            Math.max(row.clientWidth - 32, 0) / content.offsetWidth,
            Math.max(row.clientHeight - 8, 0) / content.offsetHeight
          );
          return;
        }
        const timeWrap = this.$refs.timeWrap;
        const timeTextInner = this.$refs.timeTextInner;

        this.timeScale = 1;
        if (!this.timeShowFlg || !timeWrap || !timeTextInner) {
          return;
        }

        const availableWidth = Math.max(timeWrap.clientWidth - 8, 0);
        const textWidth = Math.ceil(timeTextInner.scrollWidth);

        if (!availableWidth || !textWidth || textWidth <= availableWidth) {
          return;
        }

        this.timeScale = Number(
          Math.min((availableWidth / textWidth) * 0.98, 1).toFixed(4)
        );
      });
    },
    addZero(s) { return s < 10 ? "0" + s : s; },
    toCall() { this.$emit("callTeam"); },
    user() { this.$router.push("/user"); },
    iosOrAndroid() { this.isIos = window.location.href.includes("ios"); },
    async loadCachedNames() {
      const db = await this.$root.openDB();
      return new Promise(resolve => {
        const tx = db.transaction('backgrounds');
        const store = tx.objectStore('backgrounds');
        const req = store.getAllKeys();
        req.onsuccess = () => resolve(req.result);
      });
    },
    async saveImageToCache(name, blob) {
      const db = await this.$root.openDB();
      const tx = db.transaction('backgrounds', 'readwrite');
      tx.objectStore('backgrounds').put({ name, blob });
      return tx.complete;
    },
    async getImageFromCache(name) {
      const db = await this.$root.openDB();
      return new Promise(resolve => {
        const tx = db.transaction('backgrounds');
        const req = tx.objectStore('backgrounds').get(name);
        req.onsuccess = () => resolve(req.result?.blob || null);
      });
    },
    async deleteImageFromCache(name) {
      const db = await this.$root.openDB();
      const tx = db.transaction('backgrounds', 'readwrite');
      tx.objectStore('backgrounds').delete(name);
      return tx.complete;
    },
  },
  computed: {
    isExtraLargeTime() {
      return this.timeShowFlg && Number(this.timeShowFontSize) === 4;
    },
    timeShowFontSizeClass() {
      const size = Number(this.timeShowFontSize) || 2;
      if (size === 3) return "time-size-large";
      if (size === 1) return "time-size-small";
      return "";
    },
    availHeight() { return window.screen.availHeight + "px"; },
    backgroundStyle() {
      if (this.isExtraLargeTime) {
        return {
          backgroundImage: this.darkMode ? "none" : `url(${this.imageUrl})`,
          height: this.clockViewportHeight + "px",
        };
      }
      return !this.darkMode
          ? { backgroundImage: `url(${this.imageUrl})`, height: this.isIos ? this.availHeight : "" }
          : "";
    },
  },
};
</script>

<style scoped>
.topDiv {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  overflow: hidden;
  user-select: none;
}

/* 顶部 20%：设置按钮行 */
.setting-row {
  height: 20%;
  position: relative;
}
.setting {
  position: absolute;
  top: 2rem;
  right: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  padding: 0.5rem;
  font-size: 2rem;
}

/* 中部 30%：日期 + 时间 */
.date-time-row {
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}
.date {
  display: flex;
  justify-content: center;
  width: 100%;
}
.date p {
  margin: 0 0.5rem;
  font-size: 1.8rem;
  font-weight: bold;
  white-space: nowrap;
}
.time-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}
.time {
  margin-top: 0.3rem;
  font-size: 4.8rem;
  font-weight: 700;
  display: inline-block;
  white-space: nowrap;
  transform-origin: center center;
  text-align: center;
}
.time span {
  display: inline-block;
  white-space: nowrap;
}
.date-time-row.time-size-small .date p {
  font-size: 1.5rem;
}
.date-time-row.time-size-small .time {
  font-size: 3.8rem;
}
.date-time-row.time-size-large .date p {
  font-size: 2.2rem;
}
.date-time-row.time-size-large .time {
  font-size: 6rem;
}

/* 底部 50%：拨打 & 录音 */
.action-row {
  /*height: 50%;*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.action-row.has-record > .to-call,
.action-row.has-record > .record-btn {
  /*height: 50%;*/
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-row.no-record > .to-call {
  /*height: 100%;*/
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 拨打按钮 */
.to-call {
  flex: 0 0 12rem;
  width: 12rem;
  height: 12rem;
  background-color: #27ae60;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.phone_icon {
  font-size: 8rem;
  color: #fff;
}

/* 录音按钮 */
.record-btn {
  cursor: pointer;
  margin: 10px 0;
}
.record-icon {
  width: 7.5rem;
  height: 7.5rem;
}
.record-hint {
  font-size: 11px;
  text-align: center;
  line-height: 1.2;
}

.memo-popup {
  background-color: #e6f2ff;
  padding: 20px;
  width: 80vw;
  max-width: 350px;
}
.memo-title {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
}
.memo-input {
  margin-bottom: 10px;
}
.memo-hint {
  font-size: 12px;
  color: #666;
  margin-bottom: 15px;
}
.memo-buttons {
  display: flex;
  justify-content: space-evenly;
}
.memo-buttons .van-button {
  width: 45%;
}

/* 暗黑模式覆盖 */
.darkClass {
  background-color: black;
}
.darkClass .date-time-row .date p,
.darkClass .date-time-row .time,
.darkClass .date-time-row .time span {
  color: #fff;
}
.darkClass .to-call {
  background-color: #4b4b4b;
}
.darkClass button {
  background-color: #4b4b4b;
  border-color: #4b4b4b;
}
.record-button-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
}

/* 特大模式按可用高度分配时钟区域，按钮始终独立占位。 */
.topDiv.extra-large-clock {
  box-sizing: border-box;
  overflow-y: auto;
  padding: calc(var(--tsunagaru-safe-area-top, 0px) + 4px) env(safe-area-inset-right, 0px)
    calc(var(--tsunagaru-safe-area-bottom, 0px) + 8px) env(safe-area-inset-left, 0px);
}
.extra-large-clock .setting-row {
  flex: 0 0 56px;
  height: 56px;
}
.extra-large-clock .setting {
  top: 8px;
  right: 12px;
  width: 48px;
  height: 48px;
  font-size: 28px;
}
.extra-large-clock .date-time-row {
  position: relative;
  flex: 1;
  height: auto;
  min-height: 8rem;
  overflow: hidden;
  color: #000;
}
.extra-clock-content {
  position: absolute;
  top: 4px;
  left: 50%;
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10vw;
  line-height: 1.15;
  transform-origin: top center;
}
.extra-clock-content .date {
  width: auto;
  flex-direction: column;
  text-align: left;
}
.extra-clock-content .date p {
  margin: 0;
  font-size: 1em;
}
.extra-clock-content .time {
  margin-top: 0;
  font-size: 2.6em;
  line-height: 1.05;
  font-variant-numeric: tabular-nums;
}
.extra-large-clock .action-row {
  flex: 0 0 auto;
  padding: 4px 12px 0;
}
.extra-large-clock .record-btn {
  margin: 6px 0 0;
}
.extra-large-clock .record-button-container {
  padding: 4px 0;
}
@media (max-height: 650px) {
  .extra-large-clock .setting-row {
    flex-basis: 0;
    height: 0;
  }
  .extra-large-clock .date-time-row {
    align-self: center;
    width: calc(100% - 104px);
  }
}
</style>
